const RESERVED_ROOT_SEGMENTS = new Set(['index', 'article']);

const normalizeSiteName = (siteName?: string): string | undefined => {
  const normalized = siteName?.trim();
  return normalized || undefined;
};

export const getCurrentSiteName = (pathname = window.location.pathname) => {
  const [firstSegment] = pathname
    .split('/')
    .filter(Boolean)
    .map(segment => decodeURIComponent(segment));

  if (!firstSegment || RESERVED_ROOT_SEGMENTS.has(firstSegment)) {
    return undefined;
  }

  return firstSegment;
};

const buildSitePath = (path: string, siteName?: string): string => {
  const normalizedPath = path.replace(/^\/+/, '');
  const resolvedSiteName = normalizeSiteName(siteName) || getCurrentSiteName();

  if (!resolvedSiteName) {
    return `/${normalizedPath}`;
  }

  return `/${encodeURIComponent(resolvedSiteName)}/${normalizedPath}`;
};

export const homePath = (siteName?: string): string => {
  return buildSitePath('index', siteName);
};

/** 文章详情路由：地址优先展示 slug，同时保留 documentId 供详情接口使用 */
export function articlePath(
  slugOrDocumentId?: string,
  siteName?: string,
  documentId?: string
): string {
  const slug = slugOrDocumentId?.trim() || '';
  const id = documentId?.trim() || '';
  const segment = slug || id;
  const path = buildSitePath(
    `article/${encodeURIComponent(segment)}`,
    siteName
  );

  if (!id || id === segment) {
    return path;
  }

  return `${path}?documentId=${encodeURIComponent(id)}`;
}
